const rejectedStatuses = [400, 401, 403, 404, 409, 419, 422, 426, 429];

function uncertainFeeError() {
  const error = new Error('Powder fee write has not been confirmed by a project reload');
  error.userMessage = 'Eine Pulverpauschale ist noch nicht eindeutig bestätigt. Bitte den Projektbestand erneut prüfen; der Zuschlag wird nicht erneut gesendet.';
  return error;
}

export async function synchronizeProjectPowderFees(engine, api, { projectConfirmed = false } = {}) {
  const projectId = engine.selectedProject?.id;
  const assertContext = () => {
    if (!projectId || engine.selectedProject?.id !== projectId) throw new Error('Project changed during powder fee synchronization');
  };
  const reload = async () => {
    if (await engine.refreshSavedArticles({ syncCart: false }) !== true) throw new Error('Powder fee project reload failed');
    assertContext();
  };
  assertContext();
  if (!projectConfirmed) await reload();
  assertContext();
  const attempts = engine.powderFeeAttempts[projectId] ||= {};
  const desiredFees = new Map();
  const existingFees = [];
  for (const savedArticle of engine.savedArticles) {
    let config;
    try { config = JSON.parse(savedArticle.artikel_json); } catch { continue; }
    if (config.type === 'powder_fee') {
      existingFees.push({ savedArticle, config });
    } else {
      const pricing = config.ralPricing;
      if (pricing?.key && pricing.powderFee !== null && pricing.powderFee !== ''
        && Number.isFinite(Number(pricing.powderFee))) desiredFees.set(pricing.key, pricing);
    }
  }
  // A GET can resolve a lost POST response; absence cannot prove that a write was rejected.
  for (const key of Object.keys(attempts)) {
    if (!existingFees.some(fee => fee.config.powderFeeKey === key)) throw uncertainFeeError();
    delete attempts[key];
  }
  const keptKeys = new Set();
  let changed = false;
  for (const fee of existingFees) {
    assertContext();
    const key = fee.config.powderFeeKey;
    if (!desiredFees.has(key) || keptKeys.has(key)) {
      try {
        await api.delete(`/api/gespeicherteartikel/${fee.savedArticle.id}`, {
          data: engine.actorParams(), skipAutomaticRetry: true,
        });
      } catch (error) {
        if (error.response?.status !== 404) throw error;
      }
      changed = true;
    } else keptKeys.add(key);
  }
  for (const [key, pricing] of desiredFees) {
    assertContext();
    if (keptKeys.has(key)) continue;
    const feeValue = Number(pricing.powderFee);
    const config = {
      type: 'powder_fee', isSummaryAdjustment: true, powderFeeKey: key,
      text: `Pulverpauschale RAL ${pricing.ralCode} / ${pricing.manufacturerArticleNumber}`,
      calculationType: 'amount', value: feeValue, percentValue: null, amountValue: feeValue,
    };
    attempts[key] = true;
    try {
      const response = await api.post('/api/gespeicherteartikel', {
        position_bezeichnung: 'Pulverpauschale', artikel_json: JSON.stringify(config),
        anzahl: 1, notizen: '', projekt_id: projectId, ...engine.actorParams(),
      }, { skipAutomaticRetry: true });
      if (!response?.data?.id) throw uncertainFeeError();
    } catch (error) {
      if (rejectedStatuses.includes(error.response?.status)) delete attempts[key];
      else error.userMessage = uncertainFeeError().userMessage;
      throw error;
    }
    changed = true;
  }
  if (changed) {
    await reload();
    for (const key of Object.keys(attempts)) {
      const confirmed = engine.savedArticles.some(position => {
        try {
          const config = JSON.parse(position.artikel_json);
          return config.type === 'powder_fee' && config.powderFeeKey === key;
        } catch { return false; }
      });
      if (!confirmed) throw uncertainFeeError();
      delete attempts[key];
    }
  }
}
